module.exports = __webpack_public_path__ + "img/store-sittard.f40b4be7.png";